var site = site || {};

(function ($) {
  Drupal.behaviors.productFullV1 = {
    attach: function (context, settings) {
      var $descriptionMore = $('.js-description-more', context);
      var $descriptionLess = $('.js-description-less', context);
      var $descriptionShort = $('.product-full__description--short', context);
      var $descriptionLong = $('.product-full__description--long', context);
      var $reviewBlock = $('.spp-share-container', context);
      var $mobileReviewBlock = $('.product-full_review-mobile', context);
      var $selectboxWrapper = $('.selectbox-wrapper', context);

      // product descriptions
      $descriptionMore.once().on('click', function () {
        $descriptionShort.addClass('hidden');
        $descriptionLong.removeClass('hidden');
        $descriptionMore.addClass('hidden');
      });

      $selectboxWrapper.once().on('click', function () {
        var e = document.createEvent('MouseEvents');

        e.initMouseEvent('mousedown');
        $(this).find('select')[0].dispatchEvent(e);
      });

      $descriptionLess.once().on('click', function () {
        $descriptionShort.removeClass('hidden');
        $descriptionLong.addClass('hidden');
        $descriptionMore.removeClass('hidden');
      });

      if (site.client.isMobile) {
        $reviewBlock.remove();
        $mobileReviewBlock.append($reviewBlock);
      }
    }
  };
})(jQuery);
